import { createJSONRequest } from '@/api/create-request'

export interface SubscribePayload {
  first_name: string
  last_name: string
  company_name: string
  address_line1: string
  address_line2?: string | null
  address_city: string
  address_postal_code: string
  address_country: string
  vat_number?: string | null
}

export interface SubscribeResponse {
  checkout_url: string
}

export interface SubscribeFromTrialResponse {
  checkout_url: string | null
  fallback: boolean
  prefill?: Record<string, string | null>
}

export interface PortalResponse {
  portal_url: string
}

export const subscribe = (data: SubscribePayload): Promise<SubscribeResponse> =>
  createJSONRequest({
    url: '/api/transition-reports/checkout/subscribe',
    method: 'POST',
    data,
  })

export const subscribeFromTrial = (): Promise<SubscribeFromTrialResponse> =>
  createJSONRequest({
    url: '/api/transition-reports/checkout/subscribe-from-trial',
    method: 'POST',
  })

export const getPortalUrl = (): Promise<PortalResponse> =>
  createJSONRequest({
    url: '/api/transition-reports/portal',
    method: 'POST',
  })
